import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import {
  Row,
  Col,
  Input,
  Select,
  Pagination,
  DatePicker,
  Upload,
  Button,
  Table,
  message,
  Modal,
  Spin,
  Tag,
} from "antd";
import "../returnGoods/index.less";
import common from "@/public/common";
import _ from "lodash";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
import {
  tokenConfig,
  getCookie,
  getSid,
  outformat,
  getModerId,
} from "../../public/utils";
import {
  fetchDeliveryList,
  fetchDeliveryDictionary,
  cancelDelivery,
  updateDeliveryExpectDate,
  exportDelivery,
  exportBatchDelivery,
  fetchPurchaseForSupplier,
} from "./service";

const { Option } = Select;
const host = window.location.host;

const DeliverListNew = (props) => {
  const [sping, setSping] = useState(false);
  const [row, setRow] = useState([]);
  const [data, setData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState({
    BeginTime: moment(new Date()).subtract(1, "months").format("YYYY-MM-DD"),
    EndTime: moment(new Date()).format("YYYY-MM-DD"),
  });
  const [statusList, setStatusList] = useState([]);
  const [whidList, setWhidList] = useState([]);
  const [dateTypeList, setDateTypeList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalParams, setModalParams] = useState({});
  const [changeLoading, setChangeLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleObj, setVisibleObj] = useState({});
  const [uploadBtnLoading, setUploadBtnLoading] = useState(false);
  const isFirstRender = useRef(true);

  // 获取查询发货单状态信息、仓库信息（新字典接口）
  const getStatus = useCallback(async () => {
    try {
      const dictRes = await fetchDeliveryDictionary();
      if (String(dictRes.data.code) === '0') {
        const dictData = dictRes.data.data || {};
        setStatusList(dictData.delivery_status_list || []);
        setWhidList(dictData.warehouse_list || []);
        setDateTypeList(dictData.date_type_list || []);
        setCompanyList(dictData.common_company_list || []);
      }
    } catch (err) {
      message.error("获取字典数据失败");
    }
  }, []);

  // 获取列表信息
  const getList = useCallback(async () => {
    setSping(true);
    try {
      const res = await fetchDeliveryList({
        page: pageNo,
        page_size: pageSize,
        delivery_code: search.DeliveryCode || '',
        product_code: search.ItemCode || '',
        delivery_status: search.Status || '',
        warehouse_code: search.WHID || '',
        is_supplier_delivery: search.IsSupplierDelivery || '',
        date_type: 'create',
        date_start: getFormatTime('BeginTime', search.BeginTime),
        date_end: getFormatTime('EndTime', search.EndTime),
        check_type: '00',
        service: 'scs',
      });
      if (String(res.data.code) === '0') {
        const respData = _.get(res, 'data.data') || {};
        // 兼容两种返回结构：直接分页对象 {list,total} 或 嵌套 page_info_list
        const pageInfo = respData.page_info_list || respData;
        console.log('来货单列表返回结构：', respData);
        setTotal(pageInfo.total || 0);
        setData(pageInfo.list || []);
      }
    } catch (err){
      // error handled by ajaxApi
    } finally {
      setSping(false);
    }
  }, [search, pageNo, pageSize]);

  // 初始化：获取字典 + 列表
  useEffect(() => {
    getStatus();
    getList();
  }, []);

  // 分页变化时刷新列表（跳过首次渲染，因为初始化已经调用过）
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    getList();
  }, [pageNo, pageSize]);

  // 搜索条件input框值更改
  const inputChange = (name, e) => {
    setSearch((prev) => ({ ...prev, [name]: e.target.value }));
  };

  // 搜索条件单据类型更改值
  const selectChange = (name, val) => {
    setSearch((prev) => ({ ...prev, [name]: val }));
  };

  // 时间选择
  const changTime = (name, val) => {
    setSearch((prev) => ({
      ...prev,
      [name]: val ? moment(val).format("YYYY-MM-DD") : val,
    }));
  };

  // 开始时间补 00:00:00，结束时间补 23:59:59
  const getFormatTime = (name, val) => {
    if (!val) return null;
    return name === "BeginTime" ? val + "T00:00:00" : val + "T23:59:59";
  };

  // 搜索
  const onSearch = () => {
    setRow([]);
    setSelectedRowKeys([]);
    setPageNo(1);
    setPageSize(15);
    getList();
  };

  // 重置
  const onReset = () => {
    setRow([]);
    setSelectedRowKeys([]);
    setSearch({
      BeginTime: moment(new Date()).subtract(1, "months").format("YYYY-MM-DD"),
      EndTime: moment(new Date()).format("YYYY-MM-DD"),
    });
  };

  // 导出
  const onExport = () => {
    exportDelivery(
      {
        delivery_code_list:
          row.length > 0 ? row.map((e) => e.delivery_code) : [],
        service: 'scs',
      },
      "来货单" + moment(new Date()).format("YYYYMMDD") + ".xls"
    );
  };

  // 随货同行单导出（新接口）
  const deliveryExcel = async () => {
    if (row.length === 0) {
      message.error("请选择要导出的来货单");
      return;
    }
    exportBatchDelivery(
      {
        delivery_code_list: row.map((e) => e.delivery_code),
      },
      "随货同行单" + moment(new Date()).valueOf("x") + ".xlsx"
    );
  };

  // 撤销发货
  const revoke = async (name, item) => {
    let deliveryCodes;
    if (name === "more") {
      if (row.length > 0) {
        for (let i = 0; i < row.length; i++) {
          if (_.get(row[i], "delivery_status") !== "awaiting") {
            message.error("来货单非待收货状态无法撤销");
            return;
          }
        }
        deliveryCodes = row.map((r) => r.delivery_code);
      }
    } else {
      deliveryCodes = [item.delivery_code];
    }
    try {
      for (const code of deliveryCodes) {
        const res = await cancelDelivery({
          delivery_code: code,
        });
        if (String(res.data.code) === '0') {
          message.success("撤销成功!");
        }
      }
      getList();
    } catch (err){
      // error handled by ajaxApiNew
    }
  };

  // 跳转单据详情
  const goDetails = (name, item) => {
    if (name === "deliver") {
      window.open(
        "http://" +
          host +
          "/deliverDetailsNew?DeliveryID=" +
          item.id +
          "&DeliveryCode=" +
          item.delivery_code
      );
    } else {
      // 订单编号跳转（老接口查询订单状态，暂保留）
      const poCode = item;
      fetchPurchaseForSupplier({ POCode: poCode, Type: "" }).then((res) => {
        if (res.data.error_code === 0) {
          if (typeof res.data.data !== "string") {
            if (
              res.data.data[0].status_for_supplier_name === "待发货" ||
              res.data.data[0].status_for_supplier_name === "部分发货"
            ) {
              window.open(
                "http://" +
                  host +
                  "/waitBuyOrderDetails?POID=" +
                  res.data.data[0].poid +
                  "&code=" +
                  poCode
              );
            } else {
              window.open(
                "http://" +
                  host +
                  "/main/orderAdmin/buyOrderDetails?POID=" +
                  res.data.data[0].poid +
                  "&code=" +
                  poCode
              );
            }
          } else {
            message.error("没有相关订单");
          }
        } else {
          message.error(res.data.error_message);
        }
      });
    }
  };

  // 打印随货同行单
  const print = (item) => {
    window.open("http://" + host + "/withPrintNew?DeliveryCode=" + item.delivery_code);
  };

  // 表格分页
  const pageOnChange = (val) => {
    setPageNo(val);
  };

  const sizeOnchange = (current, size) => {
    setPageNo(current);
    setPageSize(size);
  };

  // 修改预计到货日期
  const openChangeDate = (record) => {
    setIsModalOpen(true);
    setModalParams({
      ...record,
      expectDate: _.get(record, "expect_date")
        ? moment(_.get(record, "expect_date"))
        : null,
    });
  };

  const changeDate = (expectDate) => {
    setModalParams((prev) => ({ ...prev, expectDate }));
  };

  const handleOk = async () => {
    const { expectDate } = modalParams;
    const expectDateLong = moment(expectDate).valueOf();
    if (!expectDate) {
      message.error("请选择预计到货日期");
      return;
    }
    if (expectDateLong < moment().startOf("day")) {
      message.error("预计到货日期不能小于今天！");
      return;
    }
    setChangeLoading(true);
    try {
      const res = await updateDeliveryExpectDate({
        delivery_code: _.get(modalParams, "delivery_code"),
        expect_date: expectDateLong,
      });
      if (String(res.data.code) === '0') {
        message.success("修改成功！");
        setTimeout(() => {
          getList();
          handleCancel();
        }, 1500);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setModalParams({});
    setChangeLoading(false);
  };

  // UDI附件上传
  const handleVisibleChange = (newVisible, key) => {
    setVisibleObj((prev) => ({ ...prev, [key]: newVisible }));
  };

  const getPersonProps = (key) => {
    return {
      name: "file",
      action: common.scpUrl + "order/upload-udi-annex",
      headers: { ...tokenConfig },
      data: (file) => {
        return {
          admin_id: getModerId(),
          delivery_code: _.get(selectedRowKeys, "0"),
          file,
          sid: getSid(),
        };
      },
      accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      beforeUpload: (file) => {
        if (
          ![
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
          ].includes(file.type)
        ) {
          message.error("请上传excel文件！");
        }
        return [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].includes(file.type)
          ? true
          : Upload.LIST_IGNORE;
      },
      onChange: (info) => {
        setUploadBtnLoading(true);
        if (info.file.status !== "uploading") {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === "done") {
          const code = _.get(info, "file.response.code");
          if (code == "0") {
            message.success(`${info.file.name}导入成功`);
            getList();
            setVisibleObj((prev) => ({ ...prev, udiImport: false }));
            setSelectedRowKeys([]);
          }
          setUploadBtnLoading(false);
        } else if (info.file.status === "error") {
          message.error(`${info.file.name}导入失败`);
          setUploadBtnLoading(false);
        }
      },
    };
  };

  const columns = useMemo(
    () => [
      {
        title: "来货单号",
        dataIndex: "delivery_code",
        width: 250,
        render: (text, record) => (
          <div style={{ position: "relative" }}>
            <a onClick={() => goDetails("deliver", record)}>{text || "--"}</a>
            {text && text.includes("-") && (
              <Tag style={{ marginLeft: "4px" }} color="green">
                历史订单
              </Tag>
            )}
          </div>
        ),
      },
      {
        title: "订单编号",
        dataIndex: "purchase_code_list",
        render: (text) => {
          const code = Array.isArray(text) && text.length ? text[0] : text;
          return (
            <a onClick={() => goDetails("order", code)}>{code || "--"}</a>
          );
        },
      },
      {
        title: "是否代发",
        dataIndex: "is_supplier_delivery",
        width: 90,
        render: (text) => <span>{text ? "是" : "否"}</span>,
      },
      {
        title: "仓库",
        dataIndex: "warehouse_name",
        render: (text) => <span>{text || "--"}</span>,
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        render: (text) => (
          <span>{text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""}</span>
        ),
      },
      {
        title: "预计到货日期",
        dataIndex: "expect_date",
        render: (text, record) => (
          <span>
            {text ? moment(text).format("YYYY-MM-DD") : ""}
            {_.get(record, "delivery_status") == "awaiting" && (
              <a
                onClick={() => openChangeDate(record)}
                style={{ marginLeft: 4 }}
              >
                修改
              </a>
            )}
          </span>
        ),
      },
      {
        title: "来货数量",
        dataIndex: "sum_quantity",
      },
      {
        title: "入库数量",
        dataIndex: "sum_in_stock_quantity",
      },
      {
        title: "状态",
        dataIndex: "delivery_status_name",
        render: (text, record) => {
          const status = _.get(record, "delivery_status");
          const isActive = status === "awaiting" || status === "partinstock";
          return (
            <span>
              {isActive ? (
                <span style={{ color: "#8BC826" }}>{text}</span>
              ) : (
                <span>{text}</span>
              )}
            </span>
          );
        },
      },
      {
        title: "操作",
        render: (text, record) => {
          const canRevoke = _.get(record, "delivery_status") === "awaiting" &&
            !record.is_supplier_delivery;
          return (
            <div>
              {!record.is_supplier_delivery && (
                <a onClick={() => print(record)}>打印随货同行单</a>
              )}
              <a
                style={{
                  marginLeft: "4px",
                  display: canRevoke ? "inline-block" : "none",
                }}
                onClick={() => revoke("alone", record)}
              >
                撤销发货
              </a>
              <a
                style={{ marginLeft: "16px" }}
                onClick={() => {
                  window.open(
                    "/deliverDetailsNew?DeliveryID=" +
                      record.id +
                      "&DeliveryCode=" +
                      record.delivery_code +
                      "&Files=true"
                  );
                }}
              >
                发货附件导入
              </a>
            </div>
          );
        },
      },
    ],
    []
  );

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, selectedRows) => {
      let _row = _.concat(JSON.parse(JSON.stringify(row)), selectedRows);
      _row = _.uniqWith(_row, _.isEqual);
      let _rows = [];
      if (row.length !== 0) {
        keys.forEach((item) => {
          const idx = _row.findIndex((e) => e.delivery_code === item);
          if (idx >= 0) {
            _rows.push(_row[idx]);
          }
        });
      } else {
        _rows = _row;
      }
      setRow(_rows);
      setSelectedRowKeys(keys);
    },
  };

  return (
    <div className="returnList">
      <Spin spinning={sping}>
        <div className="search">
          <Row style={{ marginBottom: "25px" }}>
            <Col span={5}>
              <label
                style={{
                  width: "70px",
                  display: "inline-block",
                  textAlign: "right",
                }}
              >
                {" "}
                单 号：
              </label>
              <Input
                placeholder="请输入发货单号或订单编号"
                style={{ width: "70%" }}
                onChange={(e) => inputChange("DeliveryCode", e)}
                value={search.DeliveryCode}
              />
            </Col>
            <Col span={5}>
              <label>商品、货品：</label>
              <Input
                placeholder="商品（货品）名称、编码"
                style={{ width: "70%" }}
                onChange={(e) => inputChange("ItemCode", e)}
                value={search.ItemCode}
              />
            </Col>
            <Col span={5}>
              <label>发货单状态：</label>
              <Select
                placeholder="请选择"
                style={{ width: "70%" }}
                onSelect={(val) => selectChange("Status", val)}
                value={search.Status}
              >
                <Option value="">全部</Option>
                {statusList.map((item) => {
                  return (
                    <Option key={item.key_value} value={item.key_value}>
                      {item.key_name}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col span={7}>
              <label>发货时间：</label>
              <DatePicker
                value={
                  search.BeginTime
                    ? moment(search.BeginTime, "YYYY-MM-DD")
                    : ""
                }
                onChange={(val) => changTime("BeginTime", val)}
              />{" "}
              至{" "}
              <DatePicker
                value={
                  search.EndTime ? moment(search.EndTime, "YYYY-MM-DD") : ""
                }
                onChange={(val) => changTime("EndTime", val)}
              />
            </Col>
          </Row>
          <Row>
            <Col span={5}>
              <label
                style={{
                  width: "70px",
                  display: "inline-block",
                  textAlign: "right",
                }}
              >
                仓库：
              </label>
              <Select
                placeholder="请选择"
                style={{ width: "70%" }}
                onSelect={(val) => selectChange("WHID", val)}
                value={search.whid}
              >
                <Option value="">全部</Option>
                {whidList.map((item) => {
                  return (
                    <Option key={item.key_value} value={item.key_value}>
                      {item.key_name}
                    </Option>
                  );
                })}
              </Select>
            </Col>

            <Col span={5}>
              <label>&nbsp;&nbsp;&nbsp;&nbsp;是否代发：</label>
              <Select
                placeholder="请选择"
                style={{ width: "70%" }}
                onSelect={(val) => selectChange("IsSupplierDelivery", val)}
                value={search.Category}
              >
                <Option value={null}>全部</Option>
                <Option value={1}>是</Option>
                <Option value={0}>否</Option>
              </Select>
            </Col>

            <Col span={10}>
              <Button type="primary" shape="round" onClick={onSearch}>
                查询
              </Button>
              <Button
                style={{ marginLeft: "15px" }}
                shape="round"
                onClick={onReset}
              >
                重置
              </Button>
              <Button
                style={{ marginLeft: "15px" }}
                shape="round"
                onClick={onExport}
              >
                导出
              </Button>
              <Button
                style={{ marginLeft: "15px" }}
                shape="round"
                onClick={() => revoke("more")}
              >
                撤销发货
              </Button>
              <Button
                disabled={row.length === 0}
                onClick={() => deliveryExcel()}
                style={{ marginLeft: "15px" }}
                shape="round"
              >
                导出随货同行单
              </Button>
            </Col>
          </Row>
        </div>
        <div className="returnBody">
          <Table
            columns={columns}
            dataSource={data}
            rowSelection={rowSelection}
            pagination={false}
            rowKey={(record) => record.delivery_code}
          />
          <div className="pagination">
            <span className="datanum">{"共" + total + "条数据"}</span>
            <Pagination
              showQuickJumper
              showSizeChanger
              current={pageNo}
              total={total}
              pageSize={pageSize}
              pageSizeOptions={["15", "20", "30", "50", "100"]}
              onChange={pageOnChange}
              onShowSizeChange={sizeOnchange}
            />
          </div>
        </div>
      </Spin>
      <Modal
        title="修改预计到货日期"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button onClick={handleCancel}>取消</Button>,
          <Button
            type="primary"
            style={{ marginLeft: "12px" }}
            onClick={handleOk}
            loading={changeLoading}
          >
            提交
          </Button>,
        ]}
      >
        <div>
          预计到货日期：
          <DatePicker
            value={_.get(modalParams, "expectDate")}
            disabledDate={(current) => {
              return current && current < moment().startOf("day");
            }}
            onChange={changeDate}
          />
        </div>
      </Modal>
    </div>
  );
};

export default DeliverListNew;



// WEBPACK FOOTER //
// ./src/pages/deliverGoodsNew/deliverList.js